import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { provide, ref } from 'vue';
  import { IProgram } from '@/types/program';

  interface IProps {
    program: IProgram;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any) {

  
  const teleportNode = ref<HTMLDivElement>();
  const applyActionMessageVisible = ref(false);

  const showApplyActionMessage = () => {
    applyActionMessageVisible.value = true;
  };
  const hideApplyActionMessage = () => {
    applyActionMessageVisible.value = false;
  };

  provide('applyActionTeleportNode', teleportNode);
  provide('showApplyAction', showApplyActionMessage);
  provide('hideApplyAction', hideApplyActionMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default")
    ], 512), [
      [_vShow, !applyActionMessageVisible.value]
    ]),
    _withDirectives(_createElementVNode("div", {
      ref_key: "teleportNode",
      ref: teleportNode,
      class: "teleport-container"
    }, null, 512), [
      [_vShow, applyActionMessageVisible.value]
    ])
  ], 64))
}
}

})